import { Select } from "common/InputForm";
import NotFound from "common/NotFound";
import useDebounce from "common/UseDebounce";
import useFullPageLoader from "common/UseFullPageLoader";
import { SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { SiStockx } from "react-icons/si";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import { outOfStockListApi } from "services/outOfStock";
import { formatCustomDate } from "utils/dateFormat";
import findSerialNumber from "utils/findSerialNumber";

const List = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const userStatus = searchParams.get("status") || "";
  const search = searchParams.get("search") || "";
  const debouncedValue = useDebounce(search, 300);
  const [total, setTotal] = useState(0);
  const [stockList, setStockList] = useState([]);
  // console.log('stockList', stockList)
  //-----------Handel-Pagination-----------
  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };
  // ----------handle-search-------------
  const handleSearch = (e) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("search", e.target.value);
    newParams.set("page", 1);
    setSearchParams(newParams);
  };
  // ----------handle-payment-mode-------------
  // const handleDeliveryStatus = (e) => {
  //     const { name, value } = e.target;
  //     setInput({ ...input, [name]: value })
  // }

  // ----------Listing-API-------------------
  useEffect(() => {
    const fetchOrderList = async () => {
      const query = {
        page: activePage || "",
        search: debouncedValue || "",
        // startDate: input.startDate || '',
        // orderStatus: input.orderStatus || '',
      };
      onShow();
      try {
        const res = await outOfStockListApi(query);
        const { code, data } = res?.data;
        if (code === 200) {
          setStockList(data?.data || []);
          setTotal(data?.total || 0);
        }
      } catch (error) {
        console.log(error);
      } finally {
        onHide();
      }
    };
    fetchOrderList();
  }, [activePage, debouncedValue]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams.toString());

    if (activePage === 1) {
      params.delete("page");
    } else {
      params.set("page", activePage);
    }

    setSearchParams(params);
  }, [activePage, setSearchParams, searchParams]);

  const getTotalExtraQuantity = (variant) => {
    if (!variant) return "N/A";

    const current = Number(variant?.stockValue ?? 0);
    const max = Number(variant?.highStockValue ?? 0);

    const extra = max - current;

    return extra > 0 ? extra : 0;
  };
  const getPurchaseQuantity = (variant) => {
    if (!variant) return "N/A";

    const current = Number(variant?.stockValue ?? 0);
    const min = Number(variant?.outOfStockValue ?? 0);

    const extra = min - current;

    return extra > 0 ? extra : 0;
  };
  return (
    <div className="prescription-management-parent">
      {loader}
      <div className="page_title">
        <h3>Out Of Stock/Low Stock</h3>
      </div>

      <div className="search_wrapper">
        <SearchBar
          placeholder="Search..."
          onChange={handleSearch}
          value={search}
        />
        {/* 
                <div>
                    <Select
                        className="select-status-option"
                        name='orderStatus'
                        value={input?.orderStatus}
                        onChange={handleDeliveryStatus}
                    >
                        <option value="">Delivery Status</option>
                        <option value="PENDING">Pending</option>
                        <option value="ACCEPTED">Accepted</option>
                        <option value="PROCESSING">Processing</option>
                        <option value="OUT_FOR_DELIVERY">Out for Delivery</option>
                        <option value="DELIVERED">Delivered</option>
                        <option value="CANCELLED">Cancelled</option>
                    </Select>
                </div> */}
      </div>
      {/* -----main card */}
      <div className="card">
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Product Name</th>
                <th className="nowrap text-center">Current Stock Quantity</th>
                <th className="nowrap text-center">Maximum Stock Quantity</th>
                                <th className="nowrap text-center">Minimum Stock Quantity</th>

                <th className="nowrap text-center">Purchase Quantity</th>   		

                <th className="nowrap text-center">Total Extra Quantity</th>

                <th className="nowrap text-center">Updated On</th>
                {/* <th className="nowrap text-center">Action</th> */}
              </tr>
            </thead>

            <tbody>
              {stockList && stockList.length ? (
                stockList?.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, limit)}
                      </td>

                      <td className="nowrap text-center">
                        {data?.product?.name || "N/A"}
                      </td>

                      <td className="nowrap text-center">
                        {data?.product?.variant?.[0]?.stockValue ?? "N/A"}
                      </td>

                      <td className="nowrap text-center">
                        {data?.product?.variant?.[0]?.highStockValue ?? "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {data?.product?.variant?.[0]?.outOfStockValue ?? "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {getPurchaseQuantity(data?.product?.variant?.[0])}
                      </td> 
                       <td className="nowrap text-center">
                        {getTotalExtraQuantity(data?.product?.variant?.[0])}
                      </td>

                      <td className="nowrap text-center">
                        {`${formatCustomDate(data?.createdAt, "DD MMMM YYYY") || "N/A"}`}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={8}
                  msg={"Out of stock data not found"}
                  onHide={onHide}
                  icon={<SiStockx />}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default List;
